// A workflow's steps as a row of tabs, one step showing at a time.
//
// Rendered on two screens that show every step of a workflow at once — the
// Preview (editor and view) and each response under Responses — where a
// workflow of five steps stacked one after another was a scroll past four
// forms to reach the one being looked at. A visitor sees one step per screen;
// so does whoever is reading their answers or checking what the step asks.
//
// Pills rather than tabs on purpose: the screens this sits on are already
// inside a ContentTabs strip (Steps, Preview, Share, Responses), which is the
// `.nav-tabs` the e2e helpers address a tab by, and a second strip in the
// same style, one level down, would read as the same control.
//
// The selection is local and by POSITION, clamped to the steps there are, so
// removing the last step while it is selected shows the new last one rather
// than nothing. `children` renders the selected step.
import React, { useState } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";

export const StepTabs = ({ steps = [], children }) => {
  const [selected, setSelected] = useState(0);
  const index = Math.min(selected, Math.max(steps.length - 1, 0));
  const step = steps[index];

  if (!step) {
    return null;
  }

  return (
    <div className="step-tabs">
      <Nav pills className="mb-3">
        {steps.map((s, i) => (
          <NavItem key={s.name || i}>
            <NavLink
              href="#"
              active={i === index}
              data-step={s.name || i}
              onClick={(e) => {
                e.preventDefault();
                setSelected(i);
              }}
            >
              <span className={i === index ? "" : "text-muted"}>{i + 1}.</span>{" "}
              {s.label || s.name}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <div className="step-tabs-content">{children(step, index)}</div>
    </div>
  );
};

export default StepTabs;
